module.exports = __webpack_public_path__ + "static/carousel-audio-book-2aa438ff36c054a83bf5737c71dfe5af.jpeg";